var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 389,
    viewBox: "0 0 305 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_6974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.86 25.7426V187.795H188.467V44.4568C188.468 43.1092 188.203 41.7746 187.687 40.5294C187.172 39.2842 186.416 38.1528 185.463 37.1997C184.511 36.2466 183.379 35.4905 182.134 34.9747C180.889 34.4588 179.555 34.1933 178.207 34.1933H112.173V21.6394C112.173 15.9003 114.453 10.3962 118.511 6.33803C122.569 2.27986 128.073 6.46009e-06 133.812 6.46009e-06H199.099C202.481 -0.00238947 205.83 0.661694 208.956 1.95431C212.081 3.24692 214.921 5.14272 217.313 7.53338C219.706 9.92404 221.604 12.7627 222.898 15.8871C224.193 19.0115 224.86 22.3605 224.86 25.7426ZM105.885 237.53H171.19C174.033 237.531 176.848 236.972 179.475 235.886C182.102 234.799 184.489 233.205 186.5 231.196C188.51 229.186 190.106 226.8 191.194 224.174C192.283 221.548 192.843 218.733 192.844 215.89V203.322H126.78C125.433 203.322 124.098 203.056 122.853 202.54C121.608 202.025 120.477 201.269 119.524 200.315C118.572 199.362 117.816 198.231 117.301 196.986C116.785 195.74 116.52 194.406 116.521 193.058V49.7199H80.1426V211.787C80.1426 218.614 82.8547 225.162 87.6824 229.99C92.5101 234.818 99.0578 237.53 105.885 237.53Z",
    fill: "url(#paint0_linear_524_6974)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9854 386.906C37.9285 387.744 34.7685 388.144 31.5994 388.097C28.6062 388.125 25.6216 387.771 22.7181 387.043C20.1577 386.394 17.7993 385.118 15.8555 383.33C13.8384 381.401 12.3015 379.026 11.3682 376.396C10.2821 373.528 9.74081 369.901 9.74447 365.512V329.948H0.775391V311.752H9.74447V292.553H31.0399V311.752H48.6928V329.97H31.0399V362.051C31.0399 366.911 33.3292 369.339 37.9079 369.336C41.5785 369.353 45.1933 368.438 48.413 366.675V383.768C46.0756 385.116 43.5809 386.17 40.9854 386.906Z",
    fill: "url(#paint1_linear_524_6974)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.248 388.1V312.826H87.5434V388.1H66.248Z",
    fill: "url(#paint2_linear_524_6974)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6402 296.796V299.112C87.6402 299.112 87.6402 299.112 86.5168 299.112C84.944 299.112 84.6823 299.112 84.1391 299.112C83.596 299.112 80.8504 299.112 80.8504 299.112C80.8504 299.112 80.7693 299.112 80.2729 299.112C79.7764 299.112 79.5517 299.112 79.1023 299.112C78.4283 299.112 77.9996 299.112 77.4038 299.112H66.2461V295.685C66.2473 294.12 66.7487 292.62 67.6402 291.514C68.5316 290.408 69.7402 289.786 71.0003 289.786H81.9738C82.7165 289.784 83.4523 289.964 84.1391 290.315C84.826 290.666 85.4503 291.182 85.9766 291.833C86.5028 292.484 86.9206 293.257 87.2061 294.109C87.4915 294.96 87.639 295.873 87.6402 296.796Z",
    fill: "#B60126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2465 301.428L66.2465 299.112C66.2465 299.112 66.2465 299.112 67.3699 299.112C68.9427 299.112 69.2044 299.112 69.7476 299.112C70.2908 299.112 73.0364 299.112 73.0364 299.112C73.0364 299.112 73.1174 299.112 73.6139 299.112C74.1103 299.112 74.335 299.112 74.7844 299.112C75.4584 299.112 75.8871 299.112 76.483 299.112L87.6406 299.112L87.6406 302.538C87.6394 304.103 87.138 305.604 86.2465 306.71C85.3551 307.816 84.1465 308.437 82.8864 308.437L71.9129 308.437C71.1702 308.44 70.4344 308.26 69.7476 307.909C69.0608 307.558 68.4364 307.042 67.9101 306.391C67.3839 305.74 66.9661 304.967 66.6807 304.115C66.3952 303.263 66.2477 302.35 66.2465 301.428Z",
    fill: "#B60126"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.521 384.259C157.847 386.819 151.775 388.099 144.303 388.099C138.936 388.152 133.614 387.108 128.664 385.032C124.045 383.117 119.852 380.304 116.329 376.757C112.805 373.21 110.02 368.999 108.136 364.368C106.166 359.591 105.166 354.471 105.196 349.304V349.024C105.17 343.835 106.17 338.691 108.136 333.889C110.02 329.249 112.78 325.016 116.266 321.42C119.794 317.813 124.01 314.95 128.664 313C133.701 310.899 139.115 309.85 144.572 309.917C151.671 309.917 157.555 311.038 162.225 313.279C166.902 315.522 171.092 318.662 174.557 322.523L161.528 336.539C159.319 334.191 156.795 332.161 154.029 330.504C151.469 329.012 148.271 328.266 144.435 328.266C141.892 328.23 139.375 328.78 137.079 329.874C134.886 330.943 132.932 332.445 131.335 334.29C129.673 336.203 128.388 338.414 127.55 340.807C126.65 343.348 126.199 346.026 126.217 348.722V349.002C126.198 351.775 126.655 354.53 127.567 357.148C128.398 359.575 129.703 361.813 131.407 363.731C133.095 365.593 135.149 367.087 137.441 368.12C139.907 369.223 142.584 369.773 145.285 369.733C148.529 369.801 151.738 369.046 154.611 367.538C157.484 365.939 160.145 363.985 162.532 361.723L175.001 374.34C171.424 378.32 167.206 381.673 162.521 384.259Z",
    fill: "url(#paint3_linear_524_6974)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240.891 388.084L221.274 357.403L213.852 365.247V388.084H192.557V285.804H213.852V340.309L238.79 313.007H264.293L235.707 342.569L265.275 388.1L240.891 388.084Z",
    fill: "url(#paint4_linear_524_6974)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M282.828 388.1V312.826H304.124V388.1H282.828Z",
    fill: "url(#paint5_linear_524_6974)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M304.222 296.796V299.112C304.222 299.112 304.222 299.112 303.099 299.112C301.526 299.112 301.264 299.112 300.721 299.112C300.178 299.112 297.432 299.112 297.432 299.112C297.432 299.112 297.351 299.112 296.855 299.112C296.358 299.112 296.134 299.112 295.684 299.112C295.01 299.112 294.582 299.112 293.986 299.112H282.828V295.685C282.829 294.12 283.331 292.62 284.222 291.514C285.114 290.408 286.322 289.786 287.582 289.786H298.556C299.299 289.784 300.034 289.964 300.721 290.315C301.408 290.666 302.032 291.182 302.559 291.833C303.085 292.484 303.503 293.257 303.788 294.109C304.074 294.96 304.221 295.873 304.222 296.796Z",
    fill: "#B60126"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M282.829 301.428L282.829 299.112C282.829 299.112 282.829 299.112 283.952 299.112C285.525 299.112 285.786 299.112 286.33 299.112C286.873 299.112 289.618 299.112 289.618 299.112C289.618 299.112 289.699 299.112 290.196 299.112C290.692 299.112 290.917 299.112 291.366 299.112C292.04 299.112 292.469 299.112 293.065 299.112L304.223 299.112L304.223 302.538C304.221 304.103 303.72 305.604 302.829 306.71C301.937 307.816 300.729 308.437 299.468 308.437L288.495 308.437C287.752 308.44 287.016 308.26 286.33 307.909C285.643 307.558 285.018 307.042 284.492 306.391C283.966 305.74 283.548 304.967 283.263 304.115C282.977 303.263 282.83 302.35 282.829 301.428Z",
    fill: "#B60126"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_6974",
    x1: 152.501,
    y1: 247.275,
    x2: 152.501,
    y2: -32.6398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F68251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EF0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EA0031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DD002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C60029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70023"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_524_6974",
    x1: 24.7341,
    y1: 392.021,
    x2: 24.7341,
    y2: 279.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F68251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EF0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EA0031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DD002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C60029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70023"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_524_6974",
    x1: 76.8957,
    y1: 391.189,
    x2: 76.8957,
    y2: 302.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F68251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EF0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EA0031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DD002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C60029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70023"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_524_6974",
    x1: 140.098,
    y1: 391.308,
    x2: 140.098,
    y2: 299.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F68251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EF0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EA0031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DD002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C60029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70023"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_524_6974",
    x1: 228.916,
    y1: 392.298,
    x2: 228.916,
    y2: 271.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F68251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EF0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EA0031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DD002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C60029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70023"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_524_6974",
    x1: 293.476,
    y1: 391.189,
    x2: 293.476,
    y2: 302.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F68251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EF0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EA0031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DD002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C60029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70023"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_6974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.717,
    height: 237.53,
    fill: "white",
    transform: "translate(80.1406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/big-logo.e957cb9196f9a2b3b7cbcb2b0f0994b2.svg";
export { ForwardRef as ReactComponent };